// src/modules/app-views/crm/components/CardHeaderSubtitle.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { toCapitalCase } from 'utils/helpers';
import Blob from 'components/core/Blob';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CrmCardHeaderSubtitle = ({ __entity, __personContact }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  const isCompany = __entity?.entityType === 'company';
  const entityName = __entity?.name || __entity?.fullName || '';
  const contactName =
    __personContact?.name || __personContact?.fullName || '';

  if (!entityName && !contactName) return null;

  // For company: "Contact Name • Company Name"
  // For person: "Person Name"
  const parts = [];
  if (isCompany && contactName) parts.push(toCapitalCase(contactName));
  if (isCompany && entityName) parts.push(toCapitalCase(entityName));
  if (!isCompany && entityName) parts.push(toCapitalCase(entityName));

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <span className="text-muted">
      {parts.map((part, i) => (
        <span key={i}>
          {i > 0 && <Blob/>}
          {part}
        </span>
      ))}
    </span>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CrmCardHeaderSubtitle;
